import $ from 'jquery'
import Cookies from 'js-cookie'
import { Modal } from 'Modal'
import moment from 'moment'
import { parallax } from 'parallax'
import { getParam, getParams } from 'utils/url'

// Get page configuration
var config = $('[data-config]').data() || {}

// rel="external"
$('a[rel="external"]').on('click', function () {
    window.open($(this).attr('href'))
    return false
})

// Menu Toggle
$('#toggle').on('click', function () {
    $('header, nav, .nav-bg').toggleClass('open')
    return false
})

// Smoothscroll
$('a.btn, #showcase-links a, #tpbr_calltoaction').smoothScroll()

$('#difference a[data-more-text]').on('click', function () {
    var more = $('#difference .more'),
        moreText = $(this).data('more-text'),
        lessText = $(this).data('less-text'),
        text = $(more).is(':visible') ? moreText : lessText

    $(this).text(text)

    $(more).slideToggle(400)

    return false
})

// Close Overlay, Remove iframe src
$('.video-trigger').on('click', function () {
    $('#overlay').css('display', 'table')

    var videoSrc = $(this).data('src')

    var iframe = $('#overlay').find('iframe')
    iframe.attr('src', videoSrc)

    return false
})

// Close Overlay, Remove iframe src
$('#overlay .overlay-x').on('click', function () {
    $('#overlay').hide()

    var iframe = $('#overlay').find('iframe')
    iframe.attr('src', '')

    return false
})

function coalesce(nullable, fallback) {
    if (nullable === null || nullable === undefined) return fallback
    return nullable
}

// General Use Carousel
$('[data-slides]').each(function (i, container) {
    var name = container.dataset.slides
    var slideConfig = $(container).data()
    var links = $('[data-slide-nav="' + name + '"] > *')
    var indicator = $(`[data-slide-nav="${name}"] .active-indicator`)

    var targetSlide = window.location.hash ? $(container).find(window.location.hash) : null
    var initialSlide = targetSlide && targetSlide.length ? targetSlide.index() : 0

    function setActiveSlide(i) {
        if (links.length) {
            links.removeClass('is-active')
        }

        if (links[i]) {
            links[i].classList.add('is-active')

            if (indicator.length) {
                indicator
                    .css({
                        transform: 'translateY(' + $(links[i])[0].offsetTop + 'px)',
                    })
                    .height($(links[i]).height())
            }
        }
    }

    links.on('click', function (e) {
        e.preventDefault()
        var slideTo = $(e.currentTarget).index()
        $(container).slick('slickGoTo', slideTo)
    })

    $(container)
        .on('init', function (e, slick) {
            setActiveSlide(slick.currentSlide)
        })
        .on('beforeChange', function (e, slick, curr, next) {
            setActiveSlide(next)
        })
        .slick({
            dots: false,
            arrows: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplaySpeed: coalesce(slideConfig.autoplaySpeed, 3000),
            autoplay: coalesce(slideConfig.autoplay, false),
            fade: coalesce(slideConfig.fade, true),
            cssEase: 'ease-in-out',
            initialSlide: initialSlide,
        })
})

// Cover Hero Video
var timeoutId
var $videoBgAspect = $('.videobg-aspect')
var $videoBgWidth = $('.videobg-width')
var videoAspect = $videoBgAspect.outerHeight() / $videoBgAspect.outerWidth()

function videobgEnlarge() {
    let windowAspect = $(window).height() / $(window).width()
    if (windowAspect > videoAspect) {
        $videoBgWidth.width((windowAspect / videoAspect) * 100 + '%')
    } else {
        $videoBgWidth.width(100 + '%')
    }
}

$(window).on('resize', function () {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(videobgEnlarge, 100)
})

$(function () {
    videobgEnlarge()
})

/**
 * Referral cookie
 */
if (getParam('referral_code')) {
    Cookies.set('referral_code', getParam('referral_code'), { expires: 62 })
}
// Used so we can store affiliate reference for bmsu application
if (getParam('ref')) {
    Cookies.set('bmsu-ref', getParam('ref'), { expires: 90, domain: 'businessmadesimple.com' })
}

try {
    const query = window.location.search.substring(1)
    const vars = query.split('&')
    let utms = {}
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0].includes('utm')) {
            utms[pair[0]] = pair[1]
        }
    }
    if (Object.keys(utms).length) {
        Cookies.set('bmsutms', JSON.stringify(utms), { expires: 90, domain: 'businessmadesimple.com' })
    }
} catch (e) {
    console.error('bmsutm', e)
}

// Dynamically populate metafield[referral_code] hidden field if no URL parameter but Cookie stored
// Happens when a livestream form is on the page
if (
    $('input[type="hidden"][name$="_50"]') &&
    !getParam('referral_code') &&
    typeof Cookies.get('referral_code') !== 'undefined'
) {
    $('input[type="hidden"][name$="_50"').attr('value', Cookies.get('referral_code'))
}

function initLiveWorkshop() {
    const selectInput = document.getElementById('input_3_7')
    const dateInput = document.getElementById('input_3_51')

    if (!selectInput || !dateInput) return

    selectInput.onchange = e => {
        try {
            let [dateRange, ...rest] = selectInput.value.split('_')
            dateRange = dateRange.trim()

            let month, day, year

            for (const part of dateRange.split(/[\s-]+/g)) {
                if (part.match(/^\d+$/)) {
                    day = year
                    year = part
                } else {
                    month = part
                }
            }

            const targetDate = moment(`${month} ${day} ${year}`)

            if (!targetDate.isValid()) return (dateInput.value = '')

            return (dateInput.value = targetDate.format('MMMM D YYYY'))
        } catch (e) {
            dateInput.value = ''
        }
    }
}

initLiveWorkshop()

function closeCourse() {
    $('[href="#regform-1540223434"], [href="#regform-1540223719"]')
        .text(config.modalCta)
        .attr('href', '#')
        .removeClass('go-regform')
        .addClass('open-modal-form')
        .removeAttr('id')
        .on('click', function (e) {
            e.preventDefault()
        })

    setTimeout(function () {
        $('.timer').removeClass('timer--show')
    }, 10000)
}

function openTimer() {
    setTimeout(function () {
        $('.timer').addClass('timer--show')
    }, 2000)
}

function initTimer() {
    var timer = window.__timer
    if (timer && timer.isDone) {
        //closeCourse();
    } else if (timer && !timer.isDone) {
        openTimer()
        timer.on('stop', closeCourse)
    } else {
        //setTimeout(initTimer, 200);
    }
}

initTimer()

/**
 * If we got a modal form on the page, wire up the click handler to open it
 */
let modals = document.querySelectorAll('[data-modal-name]')

for (const modal of modals) {
    const content = Array.prototype.slice.call(modal.children)
    $('body').on(
        'click',
        `[data-open-modal="${modal.dataset.modalName}"], [href="#modal-${modal.dataset.modalName}"]`,
        function (e) {
            e.preventDefault()
            Modal.show(modal.dataset.title, content)
        }
    )
}

/**
 * Allow video to be triggered from top nav
 */

$('.video-trigger-link').on('click', function () {
    setTimeout(() => {
        $(':target').find('.video-trigger').click()
    })
})

/**
 * Add a temporary timestamp to the request invitation form
 */
$('.modal-form-injecttime').on('click', function (e) {
    $(e.currentTarget)
        .parents('form')
        .find('[name="target"]')
        .val(btoa(Math.floor(Date.now() / 1000) + 86400 * 2))
})

function justRequestedInvitation() {
    if (Cookies.get('alerted_about_invitation_email')) return false
    let params = getParams()

    return !!(params.inf_field_FirstName && params.inf_field_Email && params.target)
}

if (justRequestedInvitation()) {
    Cookies.set('alerted_about_invitation_email', true, { expires: 1 })
    Modal.show(
        `Thanks, ${getParam('inf_field_FirstName')}!`,
        `You're officially invited! We'll send an email confirmation to ${getParam(
            'inf_field_Email'
        )} in a few moments.`,
        { 'Open Your Invitation': 'close' }
    )
}

/**
 * Modify stripe modal form markup.
 */
function formatMoney(n, includeCents) {
    var c = 2 // precision
    var d = '.' // decimal delimiter
    var t = ',' // 3 digit delimiter
    var s = n < 0 ? '-' : '' //sign
    var i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c))))
    var j = (j = i.length) > 3 ? j % 3 : 0

    return (
        s +
        (j ? i.substr(0, j) + t : '') +
        i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + t) +
        (c && includeCents
            ? d +
              Math.abs(n - i)
                  .toFixed(c)
                  .slice(2)
            : '')
    )
}

$('.go-regform').on('click', function (e) {
    setTimeout(function () {
        if (config.renameRegform) {
            $('.regform .regform-header h2').text(config.renameRegform)
        }

        $('.regform .regform-button').each(function (i, e) {
            var text = e.innerText
            var number = text.replace('BUY - USD ', '').replace(/[^\d]+$/, '')

            if (text !== number) {
                e.innerText = 'Buy Now - $' + formatMoney(number)
            }
        })
    }, 50)
})

if (config.hideTopbar) {
    $('body').addClass('hideTopbar')
}

parallax()

/**
 * photo quote slider
 */
$('.photo-quote-slick').each(function (index, photoQuoteSlider) {
    var $slider = $(photoQuoteSlider)
    var speed = $slider.attr('data-speed') || 2000
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        adaptiveHeight: true,
        autoplaySpeed: speed,
    })
})
//video slider
$('.video-carousel-slick').each(function (index, videos) {
    var $slider = $(videos)
    var speed = $slider.attr('data-speed') || 2000
    $slider.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        adaptiveHeight: true,
        autoplaySpeed: speed,
    })
})

$(document).on('gform_post_render', function () {
    console.log('gform on page')
    $('li.gfield.readonly input').attr('readonly', 'readonly')
    $('li.gfield.gf_readonly textarea').attr('readonly', 'readonly')
})
// Dropdown Menu
$('.nav-item').hover(
    function () {
        $(this).addClass('active')
    },
    function () {
        $(this).removeClass('active')
    }
)

// Mobile Menu Dropdown Support
$('.nav-item a[data-dropdown]').on('click', function (e) {
    if (window.innerWidth < 768) {
        e.preventDefault()
        $(this).closest('.nav-item').toggleClass('active')
    }
})
